const delay = (time = 500) => {
  return new Promise((resolveInner) => {
    setTimeout(resolveInner, time);
  });
};

export default delay;
